import { Controller } from "@hotwired/stimulus"
import { calculateEnergy } from "~/lib/energy"

export default class extends Controller {
  static targets = ["sex", "age", "height", "weight", "activity", "bmr", "total", "kilojoules", "error"]

  connect() { this.calculate() }

  calculate() {
    const sex = this.sexTargets.find((input) => input.checked)?.value
    const result = calculateEnergy({ sex, age: this.ageTarget.value, height: this.heightTarget.value, weight: this.weightTarget.value, activity: this.activityTarget.value })
    this.errorTarget.hidden = Boolean(result)
    if (!result) return
    this.bmrTarget.textContent = result.bmr.toLocaleString("zh-CN")
    this.totalTarget.textContent = result.total.toLocaleString("zh-CN")
    this.kilojoulesTarget.textContent = result.kilojoules.toLocaleString("zh-CN")
  }
}
